import { createContext } from 'react'
import { CgGym } from 'react-icons/cg'
import { Link } from 'react-router-dom'

import {
  numberToBRL,
  sumTotalItemsValue,
  translatePaymentInterval,
} from '~/modules/sales/services'
import { PaymentPlan } from '~/modules/sales/types'
import { planCheckoutRoute } from '~/routes/routes'

type Props = {
  data: PaymentPlan
}

type PlanOfferContextData = {
  plan: PaymentPlan
}

export const planOfferContext = createContext<PlanOfferContextData>(
  {} as PlanOfferContextData,
)

export const PlanOffer: React.FC<Props> = ({ data }) => {
  return (
    <planOfferContext.Provider value={{ plan: data }}>
      <div className='flex border-2 bg-slate-50 rounded-xl overflow-hidden'>
        <div className='h-full w-1.5 bg-gpa-blue-500'></div>
        <div className='flex py-4 pl-2 text-gpa-blue-500'>
          <CgGym size={28} />
        </div>
        <div className='flex flex-col gap-2 p-4 flex-1 items-start'>
          <h2 className='text-xl font-bold'>Plano {data.name}</h2>
          <p>
            <span className='font-semibold'>Número de licenças</span>:{' '}
            {data.licensesAmount || 0}
          </p>
          <p>
            Valor: {numberToBRL(sumTotalItemsValue(data.metaData.items) / 100)}{' '}
            &bull; Cobrado{' '}
            {translatePaymentInterval(data.interval, data.intervalCount)}
          </p>
        </div>
        <div className='flex items-center justify-center p-4'>
          <Link
            to={planCheckoutRoute + `?plan=${data.id}`}
            className='px-3 py-2 bg-gpa-blue-500 rounded-lg font-semibold
                text-white hover:bg-[rgb(48,137,226)] transition-colors
                  duration-200'
          >
            Assinar Plano
          </Link>
        </div>
      </div>
    </planOfferContext.Provider>
  )
}
